// extracted by mini-css-extract-plugin
export var coverNews = "index-module--coverNews---B6ax";
export var figure = "index-module--figure--hvjP5";
export var image = "index-module--image--cCcg9";
export var logo = "index-module--logo--6Gdmi";
export var playIcon = "index-module--playIcon--ace6d";
export var rightContent = "index-module--rightContent--z8G2P";
export var title = "index-module--title--JKkOd";
export var videoMask = "index-module--videoMask--4XFk+";
export var videoShot = "index-module--videoShot--dUKaV";